module.exports = __webpack_public_path__ + "static/media/error-exclamation-point.0384b5fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error-exclamation-point.svg
// module id = 174
// module chunks = 1